import { motion } from "framer-motion";

export default function Manifesto({ manifesto }) {
  return (
    <section id="manifesto" className="relative bg-navy py-16 md:py-24 lg:py-28" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="overline text-barn">{manifesto?.overline}</span>
          <h2 className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
            {manifesto?.heading}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 md:gap-6">
          {manifesto?.chapters?.map((c, i) => (
            <motion.div
              key={c.number}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="bg-white/[0.04] border border-white/10 rounded-lg p-7 md:p-8 hover:bg-white/[0.07] transition-colors duration-300"
            >
              <div className="font-display font-extrabold text-2xl text-barn mb-4">{c.number}</div>
              <h3 className="font-display font-bold text-xl md:text-2xl text-white leading-snug">{c.title}</h3>
              <p className="mt-3 font-body text-base text-white/65 leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
